import { enumInventoryAggregateType } from '@rematter/frontend-lib-api-client';
import { Col } from '@rematter/ui-web';

import {
  useInventoryAggregateTypeFilter,
  useInventoryAggregateIdFilter,
} from '@/audit-log/_state/inventoryEvents.state';
import { useTranslations } from '@/audit-log/i18n/useTranslations';

export const InventoryEntityFilter = () => {
  const t = useTranslations();
  const [aggregateType] = useInventoryAggregateTypeFilter();
  const [aggregateId, setAggregateId] = useInventoryAggregateIdFilter();

  const getPlaceholder = () => {
    switch (aggregateType) {
      case enumInventoryAggregateType.Item:
        return t.inventoryEventsView.filter.selectItem;
      case enumInventoryAggregateType.Category:
        return t.inventoryEventsView.filter.selectCategory;
      case enumInventoryAggregateType.ItemGroup:
        return t.inventoryEventsView.filter.selectItemGroup;
      case enumInventoryAggregateType.InventoryTag:
        return t.inventoryEventsView.filter.selectInventoryTag;
      default:
        return '';
    }
  };

  return (
    <Col className="@InventoryEntityFilter">
      <input
        type="text"
        value={aggregateId ?? ''}
        onChange={(e) => setAggregateId(e.target.value || undefined)}
        placeholder={getPlaceholder()}
        className="w-full rounded-md border border-neutral/20 bg-white px-3 py-2 text-sm placeholder:text-neutral/40 focus:border-primary focus:outline-none"
      />
    </Col>
  );
};
